module.exports = __webpack_public_path__ + "img/published.e09e0ed8.svg";